<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/order-templates/shared/order-create-order-template/order-create-order-template.component.ts
-->
<ng-template #anchor></ng-template>
